import configEnglish from '../static/parcels-config.en.json';
import configWelsh from '../static/parcels-config.cy.json';

function bootstrap() {

  angular.element(document).ready(() => {

    const initInjector = angular.injector(['ng']);
    const $http = initInjector.get('$http');
    const lang = document.documentElement.lang;
    const localConfig = lang === 'en' ? configEnglish : configWelsh;
    let remoteConfigFile = 'parcels-config.json';

    if (document.getElementById('appConfig')) {

      remoteConfigFile = document.getElementById('appConfig').href;

    }

    $http.get(remoteConfigFile).success((remoteConfig) => {

      angular.module('app').config((configServiceProvider) => {

        configServiceProvider.config(localConfig);
        configServiceProvider.config(remoteConfig);

      });

      angular.bootstrap(document, ['app']);

    });

  });

}

export default bootstrap;


// WEBPACK FOOTER //
// ./src/utils/bootstrap.js